import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toAny',
  standalone: true
})
export class ToAnyPipe implements PipeTransform {

  transform(value: any): any {
    return value as any;
  }

}
